"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipArrow = exports.TooltipPortal = exports.TooltipProvider = exports.TooltipContent = exports.TooltipTrigger = exports.Tooltip = void 0;
const react_1 = __importDefault(require("react"));
const react_tooltip_1 = require("@radix-ui/react-tooltip");
const Tooltip_styles_1 = require("./Tooltip.styles");
/**
 * @deprecated Use `Ds.Tooltip.Provider` instead
 */
const TooltipProvider = react_tooltip_1.Provider;
exports.TooltipProvider = TooltipProvider;
/**
 * @deprecated Use `Ds.Tooltip` instead
 */
const Tooltip = react_1.default.forwardRef((_a, forwardedRef) => {
    var { delayDuration = 0, open, children } = _a, props = __rest(_a, ["delayDuration", "open", "children"]);
    return (react_1.default.createElement(react_tooltip_1.Root, Object.assign({}, props, { delayDuration: delayDuration, open: open }), children));
});
exports.Tooltip = Tooltip;
/**
 * @deprecated Use `Ds.Tooltip.Trigger` instead
 */
const TooltipTrigger = react_1.default.forwardRef(({ children, asChild = false, onBlur, tabIndex }, forwardedRef) => {
    let childrenNodeType = ""; // Identify the type of child to render different output
    if (children === null || children === void 0 ? void 0 : children.type) {
        childrenNodeType =
            typeof children.type === "string"
                ? children.type
                : children.type.displayName;
    }
    if (asChild) {
        return (react_1.default.createElement(react_tooltip_1.Trigger, { asChild: true, ref: forwardedRef, onBlur: onBlur },
            react_1.default.createElement(Tooltip_styles_1.StyledSpan, { tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0 }, children)));
    }
    switch (childrenNodeType) {
        case "button": // Html button
        case "styled.button": // Styled Component Html button
        case "Button": // Our react styled Button
            // Trigger renders a button we can't have a button inside a button. "asChild" will use the first children as trigger
            return (react_1.default.createElement(react_tooltip_1.Trigger, { asChild: true, ref: forwardedRef },
                react_1.default.createElement(Tooltip_styles_1.StyledSpan, { tabIndex: 0 }, children)));
        case "Icon":
            // StyledTrigger renders an unstyled button as a trigger, for accessibility, we want a rounded outline.
            return (react_1.default.createElement(Tooltip_styles_1.StyledTrigger, { radius: "50%", ref: forwardedRef }, children));
        case "a":
            console.error("Invalid HTML: <a> cannot appear as a child of <button> (TooltipTrigger)");
        default:
            // StyledTrigger renders an unstyled button as a trigger, for accessibility, we want a square outline.
            return (react_1.default.createElement(Tooltip_styles_1.StyledTrigger, { radius: "0", ref: forwardedRef },
                react_1.default.createElement(Tooltip_styles_1.StyledSpan, { tabIndex: 0 }, children)));
    }
});
exports.TooltipTrigger = TooltipTrigger;
/**
 * @deprecated Use `Ds.Tooltip.Content` instead
 */
const TooltipContent = react_1.default.forwardRef((_a, forwardedRef) => {
    var { children, align, side } = _a, props = __rest(_a, ["children", "align", "side"]);
    return (react_1.default.createElement(Tooltip_styles_1.StyledContent, Object.assign({}, props, { sideOffset: 4, align: align, side: side, ref: forwardedRef, onPointerDownOutside: (event) => event.preventDefault(), hideWhenDetached: true }), children));
});
exports.TooltipContent = TooltipContent;
/**
 * @deprecated Use `Ds.Tooltip.Portal` instead
 */
const TooltipPortal = react_tooltip_1.Portal;
exports.TooltipPortal = TooltipPortal;
/**
 * @deprecated Use `Ds.Arrow` instead
 */
const TooltipArrow = Tooltip_styles_1.StyledArrow;
exports.TooltipArrow = TooltipArrow;
//# sourceMappingURL=Tooltip.js.map